import { render } from "./IsManager.vue?vue&type=template&id=04b13ac4&scoped=true"
import script from "./IsManager.vue?vue&type=script&lang=js"
export * from "./IsManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b13ac4"]])

export default __exports__